// extracted by mini-css-extract-plugin
module.exports = {"projectDetails":"ProjectDetails_projectDetails__o7BwD","container":"ProjectDetails_container__SEuVz","contentKeywords":"ProjectDetails_contentKeywords__pfktW"};